import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { Router, RouterLink, RouterOutlet } from '@angular/router'
import { MatTabsModule } from '@angular/material/tabs'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'

import { UserStore } from '../../../stores/user.store'

@UntilDestroy()
@Component({
  selector: 'app-trygroup-settings-shell',
  standalone: true,
  imports: [MatTabsModule, RouterLink, RouterOutlet],
  template: `
    <section class="settings-shell">
      <div class="settings-header">
        <h2>設定</h2>
        <p>面入率取込、アクセス権限、エクスポートを管理します。</p>
      </div>

      <nav mat-tab-nav-bar [tabPanel]="tabPanel" class="settings-tabs">
        @if (canManageAccessGrants) {
          <a
            mat-tab-link
            routerLink="/trygroup-dashboard/settings/monthly-sales-performance-import"
            [active]="
              router.url.includes('/settings/monthly-sales-performance-import')
            "
          >
            面入率取込
          </a>
          <a
            mat-tab-link
            routerLink="/trygroup-dashboard/settings/access-grants"
            [active]="router.url.includes('/settings/access-grants')"
          >
            アクセス権限管理
          </a>
          <a
            mat-tab-link
            routerLink="/trygroup-dashboard/settings/export"
            [active]="router.url.includes('/settings/export')"
          >
            エクスポート
          </a>
        }
      </nav>

      <mat-tab-nav-panel #tabPanel>
        <router-outlet></router-outlet>
      </mat-tab-nav-panel>
    </section>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      .settings-shell {
        max-width: 1280px;
        margin: 0 auto;
      }

      .settings-header {
        margin-bottom: 16px;
      }

      h2 {
        margin: 0;
        font-size: 22px;
        font-weight: 800;
      }

      p {
        margin: 6px 0 0;
        color: #64748b;
        font-size: 13px;
      }

      .settings-tabs {
        margin-bottom: 16px;
        background: #ffffff;
        border: 1px solid #e2e8f0;
        border-radius: 8px;
      }
    `,
  ],
})
export class TrygroupSettingsShellComponent implements OnInit {
  canManageAccessGrants = false

  constructor(
    public readonly router: Router,
    private userStore: UserStore,
  ) {}

  ngOnInit(): void {
    this.userStore
      .getOneSelf({ useCache: true })
      .pipe(untilDestroyed(this))
      .subscribe((user) => {
        this.canManageAccessGrants = user.roles.some(
          (role) => role.code === 'SUPER_ADMIN',
        )
      })
  }
}
